import React, { useEffect, useState } from "react";
import {
  GetAllAdminDetails,
  GetdailyAnalytics,
  GetCompanyName,
  getdailyAdminAnalytics,
  getcandidateDetails,
  getCandidateLead,
} from "../../../apiServices";
import { Table, Container } from "react-bootstrap";
import {
  FormGroup,
  Pagination,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import { decryptedAdminID, MyModal, textTruncate } from "../../../utility";
import ModalContainer from "../../../components/modal_popup";
import { AiOutlineClose } from "react-icons/ai";
import { Typeahead } from "react-bootstrap-typeahead";
import { FaFilter } from "react-icons/fa";
import { useSelector } from "react-redux";
import moment from "moment";
import CustomPagination from "../../../components/Custom_ui/CustomPagination";
import { commonPopupActions } from "../../../redux-store/store";
import { useDispatch } from "react-redux";
import { RowingOutlined } from "@mui/icons-material";

function AdminDailyAnalyticsCount({ setopendailycount }) {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalElementsCount, setTotalElementsCount] = useState(0);
  const [itemsPerPage] = useState(10);
  const [adminList, setAdminList] = useState([]);
  const [opnefilter, setopnefilter] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companyNames, setCompanyNames] = useState([]);
  const [dateFilter, setDateFilter] = useState("today");
  const adminDetailsRole = useSelector((state) => state.adminDetails);
  const isSuperAdmin = adminDetailsRole.roleID === 1;
  const [dataCount, setDataCount] = useState({
    lead: 0,
    register: 0,
    interview: 0,
    attended: 0,
    offeraccept: 0,
    joindCompany: 0,
  });
  const [dataFilter, setdataFilter] = useState({
    // :
    adminId: isSuperAdmin ? "" : decryptedAdminID(),
    companyName: "",
    interviewStatus: "",
    page: 1,
    limit: itemsPerPage,
    startDate: moment().format("YYYY/MM/DD"),
    endDate: moment().format("YYYY/MM/DD"),
  });
  const Dispatch = useDispatch();

  const isTodayOrYesterday = (date) => {
    const today = moment().startOf("day");
    const yesterday = moment().subtract(1, "days").startOf("day");
    const inputDate = moment(date, "YYYY/MM/DD").startOf("day");

    return dateFilter === "today"
      ? inputDate.isSame(today)
      : dateFilter === "yesterday"
      ? inputDate.isSame(yesterday)
      : false;
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getdailyAdminAnalytics({
          ...dataFilter,
          startDate: moment(dataFilter.startDate, "YYYY/MM/DD").format(
            "YYYY-MM-DD"
          ),
          endDate: moment(dataFilter.endDate, "YYYY/MM/DD").format(
            "YYYY-MM-DD"
          ),
        });
        console.log(result.data);

        if (result && result.data.data) {
          const filteredData = result.data.data.filter((item) =>
            isTodayOrYesterday(item.created_time)
          );

          setData(filteredData);
          setTotalElementsCount(result.data.total);
          setTotalPages(Math.ceil(result.data.total / itemsPerPage) || 1);

          // setDataCount((prev) => ({
          //   ...prev,
          //   lead: result.dailyCounts.lead,
          //   register: result.dailyCounts.register,
          //   interview: result.dailyCounts.interview,
          //   attended: result.dailyCounts.attended,
          //   offeraccept: result.dailyCounts.accepted,
          //   joindCompany: result.dailyCounts.joined,
          // }));
        } else {
          setData([]);
          setTotalPages(1);
          setTotalElementsCount(0);
          setDataCount((prev) => ({
            ...prev,
            lead: 0,
            register: 0,
            interview: 0,
            attended: 0,
            offeraccept: 0,
            joindCompany: 0,
          }));
        }
      } catch (error) {
        setError(error.message);
        setTotalPages(1);
        setTotalElementsCount(0);
      }
    };

    fetchData();
  }, [dataFilter, dateFilter]);

  useEffect(() => {
    console.log(data, totalElementsCount, dataCount);
  }, [data, totalElementsCount, dataCount]);

  const handleFieldChange = (field, value) => {
    setdataFilter((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    GetAllAdminDetails()
      .then((data) => {
        const activeAdmins = data.filter(
          (item) => !item.Deactived && item.Module !== "Developer"
        );
        setAdminList(activeAdmins);
      })
      .catch(() => {
        alert("Something went wrong");
      });
  }, []);

  useEffect(() => {
    async function fetchData() {
      const result = await GetCompanyName();
      setCompanyNames(result.companyDetails || []);
    }
    fetchData();
  }, []);

  const handlePageChange = (event, pageNumber) => {
    setCurrentPage(pageNumber);
    setdataFilter((prev) => ({
      ...prev,
      page: pageNumber,
    }));
  };
  useEffect(() => {
    setCurrentPage(1);
  }, [dataFilter.startDate, dataFilter.endDate]);

  const handleCandidateDetails = async (candidateId, type) => {
    let data;
    if (type === "RegisterCandidate") {
      data = await getcandidateDetails(candidateId);
    } else if (type === "CandidateLead") {
      data = await getCandidateLead(candidateId);
    }

    // Dispatch action to show the popup and pass the fetched data
    Dispatch(
      commonPopupActions.setShowPopup({
        name: "candidateDetails",
        id: candidateId,
        type: type,
        data: data,
      })
    );
  };
  const handleCompanyNameChange = (selected) => {
    if (selected.length > 0) {
      setSelectedCompany(selected[0]);
      handleFieldChange("companyName", selected[0].companyName);
    } else {
      setSelectedCompany(null);
      handleFieldChange("companyName", "");
    }
    setdataFilter((prev) => ({
      ...prev,
      page: 1,
    }));
    setCurrentPage(1);
  };

  const handleAssignToChange = (selected) => {
    if (selected.length > 0) {
      handleFieldChange("adminId", selected[0].id);
    } else {
      handleFieldChange("adminId", "");
    }
    setdataFilter((prev) => ({
      ...prev,
      page: 1,
    }));
    setCurrentPage(1);
  };

  const handleDateFilterChange = (event) => {
    const selectedDateFilter = event.target.value;
    const today = moment().startOf("day");
    const yesterday = moment().subtract(1, "days").startOf("day");

    let startDate, endDate;

    if (selectedDateFilter === "today") {
      startDate = today.format("YYYY/MM/DD");
      endDate = today.format("YYYY/MM/DD");
    } else if (selectedDateFilter === "yesterday") {
      startDate = yesterday.format("YYYY/MM/DD");
      endDate = yesterday.format("YYYY/MM/DD");
    }

    setDateFilter(selectedDateFilter);

    setdataFilter((prev) => ({
      ...prev,
      startDate,
      endDate,
      page: 1,
    }));
  };
  const getAdminUsername = (adminId) => {
    const admin = adminList.find((admin) => admin.id == adminId);
    //console.log(admin, "admin");
    return admin ? admin.userName : "Taizo";
  };

  if (error) {
    return <div>Error: {error}</div>;
  }
  const handleselect = (e) => {
    //console.log(e.target.value, "handleselect");
    setdataFilter((prev) => ({
      ...prev,
      interviewStatus: e.target.value,
    }));
    setdataFilter((prev) => ({
      ...prev,
      page: 1,
    }));
    setCurrentPage(1);
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div>
          <strong className="fs-5">
            Daily Analytics Count ({totalElementsCount})
          </strong>
        </div>
        <div>
          <RadioGroup
            row
            aria-label="date-filter"
            name="date-filter"
            value={dateFilter}
            onChange={handleDateFilterChange}
            sx={{
              columnGap: "6px",
            }}
          >
            {["today", "yesterday"].map((option) => (
              <FormControlLabel
                key={option}
                value={option}
                control={
                  <Radio
                    sx={{
                      display: "none",
                    }}
                  />
                }
                label={option.charAt(0).toUpperCase() + option.slice(1)}
                sx={{
                  border: "1px solid #169c50",
                  borderRadius: "999px",
                  padding: "2px 16px",
                  marginRight: "12px",
                  backgroundColor:
                    dateFilter === option ? "#d7f3e8" : "transparent",
                  color: "#169c50",
                  fontWeight: 400,
                  fontSize: "11px",
                  cursor: "pointer",
                  "& .MuiFormControlLabel-label": {
                    color: "#169c50",
                  },
                }}
              />
            ))}
          </RadioGroup>
        </div>
        <div className="g-2">
          <div
            className="btn btn-success"
            onClick={() => setopnefilter(true)}
            style={{ marginRight: "10px" }}
          >
            <FaFilter /> Filter
          </div>
          <div
            className="btn btn-danger"
            onClick={() => setopendailycount(false)}
            style={{ marginRight: "10px" }}
          >
            <AiOutlineClose />
          </div>
        </div>
      </div>
      <Container
        style={{
          height: "60vh",
          overflow: "auto",
          width: "65vw",
          fontFamily: "inherit",
        }}
      >
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Candidate Name</th>
              <th>Candidate MN</th>
              <th>Company Name</th>
              <th>Assigned To</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(data) && data.length > 0 ? (
              data.map((row, index) => (
                <tr key={index}>
                  <td
                    onClick={() => {
                      handleCandidateDetails(
                        row.can_id != 0 ? row.can_id : row.can_lead_id,
                        row.can_id != 0 ? "RegisterCandidate" : "CandidateLead"
                      );
                    }}
                    className="text-primary"
                    style={{ cursor: "pointer" }}
                  >
                    {row.can_id != 0
                      ? row.first_name != null
                        ? row.first_name + " " + row?.last_name
                        : "-"
                      : row.last_name != null
                      ? row.last_name
                      : "-"}
                  </td>
                  <td>
                    {row.mobile_number != null
                      ? row.mobile_number
                      : row.canlead_mobile}
                  </td>
                  <td title={row.company_name}>
                    {row.company_name
                      ? (() => {
                          try {
                            const companyNameDetails = JSON.parse(
                              row.company_name
                            );
                            const companyName =
                              companyNameDetails.company_name || "-";
                            if (companyName.length > 15) {
                              return companyName.slice(0, 15) + "...";
                            }
                            return companyName;
                          } catch (error) {
                            console.error("Error parsing JSON", error);
                            const companyName = row.company_name || "-";
                            if (companyName.length > 15) {
                              return companyName.slice(0, 15) + "...";
                            }
                            return companyName;
                          }
                        })()
                      : "-"}
                  </td>

                  {/* <td>{getAdminUsername(row.admin_id)}</td> */}
                  <td>{row.user_name}</td>
                  <td>
                    {row.call_not_attend === 1 && (
                      <span
                        className="rounded-pill"
                        style={{
                          fontSize: "12px",
                          backgroundColor: "#eeb591",
                          border: "1px solid #f4701e ",
                          paddingLeft: "12px",
                          paddingRight: "12px",
                        }}
                      >
                        <b>Call Not Attended</b>
                      </span>
                    )}

                    {row.call_remainder === 1 && (
                      <span
                        className="rounded-pill "
                        style={{
                          fontSize: "12px",
                          backgroundColor: "#fcf3cf",
                          border: "1px solid #f1c40f",
                          paddingLeft: "12px",
                          paddingRight: "12px",
                        }}
                      >
                        <b>Call Reminder</b>
                      </span>
                    )}

                    {row.not_qualified === 1 && (
                      <span
                        className="rounded-pill "
                        style={{
                          fontSize: "12px",
                          backgroundColor: "#fdecea ",
                          border: "1px solid #d30606",
                          paddingLeft: "12px",
                          paddingRight: "12px",
                        }}
                      >
                        <b>Not Qualified</b>
                      </span>
                    )}

                    {row.is_can_lead === 1 && (
                      <span
                        className="rounded-pill "
                        style={{
                          fontSize: "12px",
                          backgroundColor: "#ebceff ",
                          border: "1px solid #a428fd ",
                          paddingLeft: "12px",
                          paddingRight: "12px",
                        }}
                      >
                        <b>Lead</b>
                      </span>
                    )}

                    {row.is_interview_attended === 1 && (
                      <span
                        className="rounded-pill "
                        style={{
                          fontSize: "12px",
                          backgroundColor: "#eefca7  ",
                          border: "1px solid #728802  ",
                          paddingLeft: "12px",
                          paddingRight: "12px",
                        }}
                      >
                        <b>Interview Attended</b>
                      </span>
                    )}
                    {row.is_offer_accepted === 1 && (
                      <span
                        className="rounded-pill "
                        style={{
                          fontSize: "12px",
                          backgroundColor: "#d2d1d3 ",
                          border: "1px solid #242324 ",
                          paddingLeft: "12px",
                          paddingRight: "12px",
                        }}
                      >
                        <b>Offer Accepted</b>
                      </span>
                    )}
                    {row.is_joined_company === 1 && (
                      <span
                        className="rounded-pill "
                        style={{
                          fontSize: "12px",
                          backgroundColor: "#ccfca7",
                          border: "1px solid #398002  ",
                          paddingLeft: "12px",
                          paddingRight: "12px",
                        }}
                      >
                        <b>Joined Company</b>
                      </span>
                    )}

                    {row.is_registered === 1 && (
                      <span
                        className="rounded-pill "
                        style={{
                          fontSize: "12px",
                          backgroundColor: "#bbd5f0",
                          border: "1px solid #3982ce",
                          paddingLeft: "12px",
                          paddingRight: "12px",
                        }}
                      >
                        <b>Registered</b>
                      </span>
                    )}

                    {row.interview_id === 0 ? (
                      <span
                        className="rounded-pill "
                        style={{
                          fontSize: "12px",
                          backgroundColor: "#f6ddcc",
                          border: "1px solid #dc7633",
                          paddingLeft: "12px",
                          paddingRight: "12px",
                        }}
                      >
                        <b>Interview Date Set</b>
                      </span>
                    ) : row.interview_id !== null &&
                      row.is_rescheduled === 0 ? (
                      <span
                        className="rounded-pill "
                        style={{
                          fontSize: "12px",
                          backgroundColor: "#d5f5e3",
                          border: "1px solid #169c50",
                          paddingLeft: "12px",
                          paddingRight: "12px",
                        }}
                      >
                        <b>Interview Scheduled</b>
                      </span>
                    ) : null}

                    {row.interview_id !== null && row.is_rescheduled === 1 && (
                      <span
                        className="rounded-pill "
                        style={{
                          fontSize: "12px",
                          backgroundColor: "#d5f1f5ff",
                          border: "1px solid #16699cff",
                          paddingLeft: "12px",
                          paddingRight: "12px",
                        }}
                      >
                        <b>Interview Rescheduled</b>
                      </span>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="5"
                  className="text-center"
                  style={{ color: "#CD1655" }}
                >
                  <b>No data available</b>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Container>
      {/* <hr />
      <div className="d-flex justify-content-between align-items-center">
        {" "}
        <div className="d-flex justify-content-between align-items-center gap-2">
          <div
            style={{
              background: "#fff",
              color: "black",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              padding: "10px",
              // maxWidth: "200px",
            }}
          >
            <strong>Lead : </strong>
            
            <span>{dataCount.lead > 0 ? dataCount.lead : 0}</span>
          </div>

          <div
            style={{
              background: "#fff",
              color: "black",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              padding: "10px",
              // maxWidth: "200px",
            }}
          >
            <strong>Registered : </strong>
            
            <span>{dataCount.register > 0 ? dataCount.register : 0}</span>
          </div>
          <div
            style={{
              background: "#fff",
              color: "black",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              padding: "10px",
              // maxWidth: "200px",
            }}
          >
            <strong>Interview : </strong>
            
            <span>{dataCount.interview > 0 ? dataCount.interview : 0}</span>
          </div>
          <div
            style={{
              background: "#fff",
              color: "black",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              padding: "10px",
              // maxWidth: "200px",
            }}
          >
            <strong>Attended : </strong>
            
            <span>{dataCount.attended > 0 ? dataCount.attended : 0}</span>
          </div>
          <div
            style={{
              background: "#fff",
              color: "black",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              padding: "10px",
              // maxWidth: "200px",
            }}
          >
            <strong>Offer accepted : </strong>
            
            <span>{dataCount.offeraccept > 0 ? dataCount.offeraccept : 0}</span>
          </div>
          <div
            style={{
              background: "#fff",
              color: "black",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              padding: "10px",
              // maxWidth: "200px",
            }}
          >
            <strong>Joined : </strong>
            
            <span>
              {dataCount.joindCompany > 0 ? dataCount.joindCompany : 0}
            </span>
          </div>
        </div>
       
      </div> */}
      <div className="d-flex justify-content-center align-items-center mt-3">
          <div>
            <Pagination
              shape="rounded"
              color="success"
              siblingCount={0}
              boundaryCount={2}
              onChange={handlePageChange}
              count={totalPages}
              page={currentPage}
              size="small"
            />
          </div>
      </div>

      {opnefilter && (
        <MyModal>
          <ModalContainer
            childComponent={
              <>
                <div className="" style={{ width: "400px" }}>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      <b>Daily Analytics Filter</b>
                    </div>
                    <div
                      className="btn btn-danger"
                      onClick={() => setopnefilter(false)}
                    >
                      <AiOutlineClose />
                    </div>
                  </div>
                  {isSuperAdmin && (
                    <FormGroup>
                      <Typeahead
                        id="assign-to-typeahead"
                        placeholder="Assigned To"
                        options={adminList}
                        labelKey={(option) => `${option.userName}`}
                        onChange={handleAssignToChange}
                        selected={
                          dataFilter.adminId !== -1
                            ? adminList.filter(
                                (admin) => admin.id === dataFilter.adminId
                              )
                            : []
                        }
                      />
                    </FormGroup>
                  )}
                </div>
                <div className="w-100 mt-2">
                  <FormGroup>
                    <Typeahead
                      id="company-name-typeahead"
                      placeholder="Company Details"
                      options={companyNames}
                      labelKey={(option) => `${option.companyName}`}
                      selected={selectedCompany ? [selectedCompany] : []}
                      onChange={handleCompanyNameChange}
                    />
                  </FormGroup>
                </div>
                <div>
                  <select
                    name="select"
                    id="select"
                    onChange={(e) => handleselect(e)}
                    value={dataFilter.interviewStatus}
                    className="form-control mt-2"placeholder="Interview status"
                  >
                    <option value="" selected disabled>
                     Interview status select option
                    </option>
                    {/* <option value={"can lead"}>Can lead</option>
                    <option value={"Call not attended"}>
                      Call not attended
                    </option>
                    <option value={"call remainder"}>Call remainder</option>
                    <option value={"not qualified"}>Not qualified</option>
                    <option value={"registered"}>Registered </option> */}
                    <option value={"Tentative Date"}>
                      Interview Date Set
                    </option>
                    <option value={"Interview Scheduled"}>
                      Interview Scheduled
                    </option>
                    <option value={"Interview Rescheduled"}>
                      Interview Rescheduled
                    </option>
                    {/* <option value={"offer accepted"}>Offer accepted</option>
                    <option value={"joined company"}>Joined company</option> */}
                  </select>
                </div>
                <div className="d-flex justify-content-end mt-2 mb-2 gap-2">
                  <div
                    className="btn btn-danger"
                    onClick={() => {
                      setdataFilter((prev) => ({
                        ...prev,
                        adminId: isSuperAdmin ? "" : decryptedAdminID(),
                        companyName: "",
                        page: 1,
                        interviewStatus: "",
                        // startDate: moment().format("YYYY/MM/DD"),
                        // endDate: moment().format("YYYY/MM/DD"),
                      }));
                      setSelectedCompany(null);
                    }}
                  >
                    Clear
                  </div>
                  <div
                    className="btn btn-success"
                    onClick={() => setopnefilter(false)}
                  >
                    Submit
                  </div>
                </div>
              </>
            }
          />
        </MyModal>
      )}
    </>
  );
}

export default AdminDailyAnalyticsCount;
